import { uploadTagItemsByTagFieldId } from '@/service/formManagementService';

const uploadTagItems = async data => {
    const {
        corporationInuseId,
        projectInuseId,
        userInuseId,
        targetUploadId,
        uploadFileUrl,
        taskId
    } = data;
    const reponse = await uploadTagItemsByTagFieldId({
        corporationInuseId,
        projectInuseId,
        userInuseId,
        targetUploadId,
        uploadFileUrl,
        taskId
    });
    return reponse;
};

export { uploadTagItems };
